<h1 class="mb-7 text-xl font-semibold text-gray-900">
  Create Push Notification
</h1>

<form [formGroup]="notificationForm">
  <!-- Notification Type -->
  <section class="mb-7">
    <label class="mb-2.5 block text-sm font-semibold text-gray-600"
      >Notification Type</label
    >
    <div class="flex gap-3">
      <!-- Rich Push -->
      <button
        type="button"
        (click)="selectType('RICH')"
        [ngClass]="
          selectedType === 'RICH'
            ? 'border-mango bg-orange-50 shadow-xl ring-2 ring-mango-bisque'
            : 'border-gray-200 bg-white hover:border-gray-300'
        "
        class="flex flex-1 cursor-pointer flex-col items-center gap-2 rounded-xl border-[1.5px] px-3 py-5 transition-all duration-150"
      >
        <div
          [ngClass]="
            selectedType === 'RICH'
              ? 'bg-mango text-white'
              : 'bg-gray-100 text-gray-500'
          "
          class="flex h-11 w-11 items-center justify-center rounded-full transition-colors duration-150"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
            />
          </svg>
        </div>
        <span class="text-sm font-semibold text-gray-800">Rich Push</span>
        <span class="text-center text-[11px] leading-tight text-gray-400"
          >Images, videos &amp; rich content</span
        >
      </button>

      <!-- Interactive Push -->
      <button
        type="button"
        (click)="selectType('INTERACTIVE')"
        [ngClass]="
          selectedType === 'INTERACTIVE'
            ? 'border-mango bg-orange-50 shadow-xl ring-2 ring-mango-bisque'
            : 'border-gray-200 bg-white hover:border-gray-300'
        "
        class="flex flex-1 cursor-pointer flex-col items-center gap-2 rounded-xl border-[1.5px] px-3 py-5 transition-all duration-150"
      >
        <div
          [ngClass]="
            selectedType === 'INTERACTIVE'
              ? 'bg-mango text-white'
              : 'bg-gray-100 text-gray-500'
          "
          class="flex h-11 w-11 items-center justify-center rounded-full transition-colors duration-150"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="size-6"
          >
            <path
              fill-rule="evenodd"
              d="M12 1.5a.75.75 0 0 1 .75.75V4.5a.75.75 0 0 1-1.5 0V2.25A.75.75 0 0 1 12 1.5ZM5.636 4.136a.75.75 0 0 1 1.06 0l1.592 1.591a.75.75 0 0 1-1.061 1.06l-1.591-1.59a.75.75 0 0 1 0-1.061Zm12.728 0a.75.75 0 0 1 0 1.06l-1.591 1.592a.75.75 0 0 1-1.06-1.061l1.59-1.591a.75.75 0 0 1 1.061 0Zm-6.816 4.496a.75.75 0 0 1 .82.311l5.228 7.917a.75.75 0 0 1-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 0 1-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 0 1-1.247-.606l.569-9.47a.75.75 0 0 1 .554-.68ZM3 10.5a.75.75 0 0 1 .75-.75H6a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 10.5Zm14.25 0a.75.75 0 0 1 .75-.75h2.25a.75.75 0 0 1 0 1.5H18a.75.75 0 0 1-.75-.75Zm-8.962 3.712a.75.75 0 0 1 0 1.061l-1.591 1.591a.75.75 0 1 1-1.061-1.06l1.591-1.592a.75.75 0 0 1 1.06 0Z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <span class="text-sm font-semibold text-gray-800"
          >Interactive Push</span
        >
        <span class="text-center text-[11px] leading-tight text-gray-400"
          >Action buttons &amp; responses</span
        >
      </button>

      <!-- Silent Push -->
      <button
        type="button"
        (click)="selectType('SILENT')"
        [ngClass]="
          selectedType === 'SILENT'
            ? 'border-mango bg-orange-50 shadow-xl ring-2 ring-mango-bisque'
            : 'border-gray-200 bg-white hover:border-gray-300'
        "
        class="flex flex-1 cursor-pointer flex-col items-center gap-2 rounded-xl border-[1.5px] px-3 py-5 transition-all duration-150"
      >
        <div
          [ngClass]="
            selectedType === 'SILENT'
              ? 'bg-mango text-white'
              : 'bg-gray-100 text-gray-500'
          "
          class="flex h-11 w-11 items-center justify-center rounded-full transition-colors duration-150"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9.143 17.082a24.248 24.248 0 0 0 3.844.148m-3.844-.148a23.856 23.856 0 0 1-5.455-1.31 8.964 8.964 0 0 0 2.3-5.542m3.155 6.852a3 3 0 0 0 5.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 0 0 3.536-1.003A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"
            />
          </svg>
        </div>
        <span class="text-sm font-semibold text-gray-800">Silent Push</span>
        <span class="text-center text-[11px] leading-tight text-gray-400"
          >Background data sync</span
        >
      </button>

      <!-- Ads -->
      <button
        type="button"
        (click)="selectType('ADS')"
        [ngClass]="
          selectedType === 'ADS'
            ? 'border-mango bg-orange-50 shadow-xl ring-2 ring-mango-bisque'
            : 'border-gray-200 bg-white hover:border-gray-300'
        "
        class="flex flex-1 cursor-pointer flex-col items-center gap-2 rounded-xl border-[1.5px] px-3 py-5 transition-all duration-150"
      >
        <div
          [ngClass]="
            selectedType === 'ADS'
              ? 'bg-mango text-white'
              : 'bg-gray-100 text-gray-500'
          "
          class="flex h-11 w-11 items-center justify-center rounded-full transition-colors duration-150"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605"
            />
          </svg>
        </div>
        <span class="text-sm font-semibold text-gray-800">Ads</span>
        <span class="text-center text-[11px] leading-tight text-gray-400"
          >Upload ad images</span
        >
      </button>
    </div>
  </section>

  <!-- Ads: Image Upload -->
  @if (selectedType === 'ADS') {
    <section class="mb-7">
      <app-input-label labelClass="label--bottom-margin font-semibold">Ad Images</app-input-label>

      <div class="mb-3 inline-flex items-center gap-[0.9rem] rounded-xl bg-mango-floralWhite px-[0.6rem] py-[0.9rem]">
        <img src="assets/images/svgs/info-circle--yellow.svg" alt="" class="h-5 w-5 flex-shrink-0" />
        <p class="text-sm text-mango-grey">Each image must be under 2MB. Accepted types: JPEG, PNG. You can select multiple files at once.</p>
      </div>

      <!-- File input trigger -->
      <input
        type="file"
        id="adFileInput"
        multiple
        accept="image/jpeg,image/png"
        class="absolute z-[-1] h-[0.1px] w-[0.1px] overflow-hidden opacity-0"
        (change)="onAdImagesSelected($event)"
      />
      <label
        for="adFileInput"
        class="inline-flex w-full cursor-pointer items-center gap-[0.62rem] rounded-xl border border-dashed border-mango-bisque px-[0.62rem]"
      >
        <div class="flex h-[2.4375rem] w-[2.4375rem] shrink-0 items-center justify-center rounded-full bg-mango-papayaWhip">
          <img src="assets/images/svgs/upload-icon--yellow.svg" alt="upload icon" />
        </div>
        <span class="px-0 py-5 text-xs leading-6 text-mango">
          {{ adImageFiles.length > 0 ? 'Add more images' : 'Select ad images' }}
        </span>
      </label>

      <!-- Preview grid -->
      @if (adImagePreviewUrls.length > 0) {
        <div class="mt-3 grid grid-cols-3 gap-3">
          @for (preview of adImagePreviewUrls; track preview; let i = $index) {
            <div class="relative rounded-lg border border-gray-200 overflow-hidden">
              <img [src]="preview" alt="Ad preview" class="h-48 w-full object-contain" />
              <button
                type="button"
                (click)="removeAdImage(i)"
                class="absolute right-1.5 top-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-white shadow-md hover:bg-red-50"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4 text-gray-500 hover:text-red-500">
                  <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                </svg>
              </button>
            </div>
          }
        </div>
        <p class="mt-2 text-xs text-gray-400">{{ adImageFiles.length }} image{{ adImageFiles.length === 1 ? '' : 's' }} selected</p>
      }

      @if (isUploadingAd) {
        <p class="mt-2 text-sm text-gray-500">Uploading images, please do not close this page...</p>
      }
    </section>
  }

  <!-- Target Audience -->
  @if (selectedType !== 'ADS') {
  <section class="mb-7">
    <app-input-label
      labelFor="target-audience"
      labelClass="label--bottom-margin font-semibold"
      >Target Audience</app-input-label
    >
    <div class="flex flex-col gap-1.5">
      <label
        [ngClass]="
          targetAudience === 'all'
            ? 'border-mango bg-mango-lightOrange'
            : 'border-gray-200 bg-white hover:bg-gray-50'
        "
        class="flex cursor-pointer items-center gap-3 rounded-lg border-[1.5px] px-3.5 py-3 transition-colors duration-150"
      >
        <input
          type="radio"
          formControlName="targetAudience"
          value="all"
          class="w-4.5 h-4.5 cursor-pointer border-gray-300 text-mango focus:ring-2 focus:ring-mango"
        />
        <div class="flex flex-col">
          <span class="text-sm font-semibold text-gray-800">All Users</span>
          <span class="text-xs text-gray-400"
            >Send to everyone on the platform</span
          >
        </div>
      </label>

      <label
        [ngClass]="
          targetAudience === 'custom'
            ? 'border-mango bg-mango-lightOrange'
            : 'border-gray-200 bg-white hover:bg-gray-50'
        "
        class="flex cursor-pointer items-center gap-3 rounded-lg border-[1.5px] px-3.5 py-3 transition-colors duration-150"
      >
        <input
          type="radio"
          formControlName="targetAudience"
          value="custom"
          class="w-4.5 h-4.5 cursor-pointer border-gray-300 text-mango focus:ring-2 focus:ring-mango"
        />
        <div class="flex flex-1 flex-col">
          <span class="text-sm font-semibold text-gray-800"
            >Custom Filters</span
          >
          <span class="text-xs text-gray-400"
            >Target specific user segments</span
          >
        </div>
        <img
          class="transition-transform duration-200"
          [ngClass]="{
            'rotate-90': targetAudience !== 'custom',
            'rotate-180': targetAudience === 'custom',
          }"
          src="assets/images/svgs/chevron-up.svg"
        />
      </label>

      <!-- Dropdown list when custom is selected -->
      @if (targetAudience === 'custom') {
        <div
          class="mt-2 rounded-lg border border-gray-200 bg-white p-3"
        >
          <div class="flex flex-col gap-2">
            <label
              *ngFor="let filter of customFilters"
              class="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 hover:bg-gray-50"
            >
              <input
                type="radio"
                [formControl]="formControl.customFilters"
                [value]="filter.value"
                class="h-4 w-4 cursor-pointer rounded border-gray-300 text-mango focus:ring-2 focus:ring-mango"
              />
              <span class="text-sm text-gray-700">{{ filter.label }}</span>
            </label>
          </div>
        </div>

        <!-- Accounts table shown when 'Specific users' is selected -->
        @if (formControl.customFilters.value === 'SPECIFIC_USERS') {
          <div class="mt-3">

            <!-- Selected Users Display -->
            <div class="mb-4">
              <div class="mb-2 flex items-center justify-between">
                <span class="text-sm font-semibold text-gray-700">Selected Users ({{ selectedAccounts.length }}/5)</span>
              </div>

              @if (selectedAccounts.length >= 5) {
                <h2 class="text-mango-red707 font-semibold text-sm mb-2">You can only select 5 users</h2>
              }
              
              @if (selectedAccounts.length > 0 && selectedAccounts.length <= 5) {
                <div class="flex flex-wrap gap-2">
                  @for (account of selectedAccounts; track account.id) {
                    <div class="flex items-center gap-1.5 rounded-full bg-mango-lightOrange px-3 py-1.5 text-sm border border-mango/20">
                      <span class="font-medium text-gray-800">{{ getAccountDisplayName(account) }}</span>
                      <button type="button" (click)="toggleAccountSelection(account)" class="text-gray-500 hover:text-red-500">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4">
                          <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                        </svg>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>

            <!-- Filters + Refresh -->
            <div class="flex gap-3">
              <app-filters [filters]="accountFilterStructure"></app-filters>
              <app-table-refresh class="mt-5" [tableKey]="'notificationUsers'"></app-table-refresh>
            </div>

            <!-- Table skeleton loader -->
            @if (isFetchingNotificationUsers$ | async) {
              <div class="mt-[0.94rem]">
                <app-table-skeleton-loader></app-table-skeleton-loader>
              </div>
            }

            <!-- Table -->
            @if (!(isFetchingNotificationUsers$ | async)) {
              <div
                class="mt-[0.94rem] rounded-lg border border-solid border-mango-gray200 bg-white"
              >
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div
                      class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
                    >
                      <table class="min-w-full leading-normal">
                        <thead>
                          <tr>
                            <th
                              class="flex border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold text-gray-600"
                            >
                              S/N
                            </th>
                            <th
                              class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
                            >
                              Name
                            </th>
                            <th
                              class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
                            >
                              Account No.
                            </th>
                            <th
                              class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
                            >
                              Account Type
                            </th>
                            <th
                              scope="col"
                              class="relative border-b-2 border-gray-200 bg-gray-100 py-3.5 pl-3 pr-4 sm:pr-6"
                            ></th>
                          </tr>
                        </thead>

                        <tbody>
                          @if (notificationUsersList$ | async; as users) {
                            @if (users.length > 0) {
                              @for (user of users; track user.id; let i = $index) {
                                <ng-container
                                  *ngTemplateOutlet="userRow; context: { data: user, i: i }"
                                ></ng-container>
                              }
                            } @else {
                              <tr>
                                <td colspan="5" class="px-5 py-6 text-center text-sm text-gray-400">
                                  No notification-enabled users found.
                                </td>
                              </tr>
                            }
                          }
                        </tbody>
                      </table>

                      <app-table-navigator
                        *ngIf="notificationUsersTotalCount$ | async as totalCount"
                        [total]="totalCount"
                        (onNavigation)="navigateNotificationUsers($event)"
                      ></app-table-navigator>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      }
    </div>
  </section>
  } <!-- end @if selectedType !== 'ADS' -->

  <!-- Message Content -->
  @if (selectedType !== 'ADS') {
  <section class="mb-7">
    <app-input-label
      labelFor="message-content"
      labelClass="label--bottom-margin font-semibold"
      >Message Content</app-input-label
    >

    <!-- Title -->
    <div class="mb-3.5">
      <app-input-label
        labelFor="notification-title"
        labelClass="label--bottom-margin"
        [isRequired]="true"
        >Title</app-input-label
      >
      <app-input
        placeholder="Enter notification title"
        [inputClass]="'input--padding'"
        formControlName="title"
      ></app-input>
    </div>

    <!-- Message -->
    <div class="mb-3.5">
      <app-input-label
        labelFor="notification-message"
        labelClass="label--bottom-margin"
        [isRequired]="true"
        >Message</app-input-label
      >

      <app-input
        type="textarea"
        placeholder="Enter your message here..."
        [rows]="4"
        [inputClass]="'input--padding'"
        formControlName="message"
        class="w-full resize-none"
      ></app-input>
    </div>

    <!-- RICH: Image URL -->
    @if (selectedType === 'RICH') {
      <ng-container>
        <div class="mb-3.5">
          <app-input-label
            labelFor="image-url"
            labelClass="label--bottom-margin"
          >
            Image URL (Optional)
          </app-input-label>
          <app-input
            placeholder="https://example.com/image.jpg"
            inputClass="input--padding"
            formControlName="image_url"
          ></app-input>
        </div>
      </ng-container>
    }

    <!-- INTERACTIVE: Action Buttons -->
    @if (selectedType === 'INTERACTIVE') {
      <ng-container>
        <div class="mb-3.5">
          <app-input-label
            labelFor="action-buttons"
            labelClass="label--bottom-margin"
            [isRequired]="true"
            >Action Buttons</app-input-label
          >
          <div class="mb-2 flex gap-2.5">
            <app-input
              placeholder="Button 1 Label"
              inputClass="input--padding flex-1"
              formControlName="action1_label"
              class="w-full"
            ></app-input>
            <app-input
              placeholder="Action URL"
              inputClass="input--padding flex-1"
              formControlName="action1_url"
              class="w-full"
            ></app-input>
          </div>
          <div class="flex gap-2.5">
            <app-input
              placeholder="Button 2 Label"
              inputClass="input--padding flex-1"
              formControlName="action2_label"
              class="w-full"
            ></app-input>
            <app-input
              placeholder="Action URL"
              inputClass="input--padding flex-1"
              formControlName="action2_url"
              class="w-full"
            ></app-input>
          </div>
        </div>
      </ng-container>
    }
  </section>
  } <!-- end @if selectedType !== 'ADS' -->

  <!-- Schedule -->
  @if (selectedType !== 'ADS') {
  <section class="mb-8">
    <app-input-label
      labelFor="schedule"
      labelClass="label--bottom-margin font-semibold"
      >Schedule</app-input-label
    >

    <span class="text-mango-gray500">Coming soon...</span>

    <!-- Disable this section and have a span saying coming soon -->
    <!-- <div class="flex flex-col gap-1.5">
      <label
        [ngClass]="
          scheduleType === 'now'
            ? 'border-mango bg-mango-lightOrange'
            : 'border-gray-200 bg-white hover:bg-gray-50'
        "
        class="flex cursor-pointer items-center gap-3 rounded-lg border-[1.5px] px-3.5 py-3 transition-colors duration-150"
      >
        <input
          type="radio"
          formControlName="scheduleType"
          value="now"
          class="w-4.5 h-4.5 cursor-pointer border-gray-300 text-mango focus:ring-2 focus:ring-mango"
        />
        <span class="text-sm font-semibold text-gray-800">Send Now</span>
      </label>

      <label
        [ngClass]="
          scheduleType === 'later'
            ? 'border-mango bg-mango-lightOrange'
            : 'border-gray-200 bg-white hover:bg-gray-50'
        "
        class="flex cursor-pointer items-center gap-3 rounded-lg border-[1.5px] px-3.5 py-3 transition-colors duration-150"
      >
        <input
          type="radio"
          formControlName="scheduleType"
          value="later"
          class="w-4.5 h-4.5 cursor-pointer border-gray-300 text-mango focus:ring-2 focus:ring-mango"
        />
        <span class="text-sm font-semibold text-gray-800"
          >Schedule for Later</span
        >
      </label>
    </div> -->

    <!-- Date & Time pickers -->
    <!-- @if (scheduleType === 'later') {
      <div class="mt-3 flex gap-2.5">
        <input
          type="date"
          formControlName="scheduledDate"
          input-date
          class="input--padding flex-[1.6] justify-end"
        />
        <input
          type="time"
          formControlName="scheduledTime"
          input-date
          class="input--padding flex-1"
        />
      </div>
    } -->
  </section>
  } <!-- end @if selectedType !== 'ADS' -->

  <!-- Footer -->
  <div class="flex items-center justify-between border-t border-gray-100 pt-5">
    <div class="flex items-center gap-1.5">
      <img
        class="h-5 w-5 rounded-full"
        src="/assets/images/svgs/info-circle--yellow.svg"
        alt="info icon"
      />
      <span class="text-xs text-gray-400"
        >{{ selectedType === 'ADS' ? 'These images will be shown to the customers' : 'Preview on device before sending' }}</span
      >
    </div>
    @if (selectedType === 'ADS') {
      <div class="flex items-center gap-3" *appHasPermission="'send_broadcast_message'">
        <button
          type="button"
          mango-button
          class="w-fit items-center justify-end"
          (click)="uploadAdImage()"
          [disabled]="!allFieldsValid() || isUploadingAd"
        >
          {{ isUploadingAd ? 'Uploading...' : 'Upload Ad Images' }}
        </button>
      </div>
    } @else {
      <div class="flex items-center gap-3" *appHasPermission="'send_broadcast_message'">
        <button
          type="button"
          (click)="saveDraft()"
          class="cursor-pointer rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-sm font-medium text-gray-600 transition-colors duration-150 hover:border-gray-300 hover:bg-gray-50"
        >
          Save Draft
        </button>
        <button
          type="button"
          mango-button
          class="w-fit items-center justify-end"
          (click)="sendNotification()"
          [disabled]="!allFieldsValid()"
        >
          Send Notification
        </button>
      </div>
    }
  </div>
</form>

<!-- Existing Ads -->
@if (selectedType === 'ADS') {
  <section class="mb-7">
    <app-input-label labelClass="label--bottom-margin font-semibold">Uploaded Ads</app-input-label>

    @if (isFetchingAds) {
      <div class="mt-[0.94rem]">
        <app-table-skeleton-loader></app-table-skeleton-loader>
      </div>
    }

    @if (!isFetchingAds) {
      <div class="mt-[0.94rem] rounded-lg border border-solid border-mango-gray200 bg-white">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table class="min-w-full leading-normal">
                <thead>
                  <tr>
                    <th class="flex border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold text-gray-600">S/N</th>
                    <th class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600">Preview</th>
                    <th class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600">Uploaded</th>
                    <th scope="col" class="relative border-b-2 border-gray-200 bg-gray-100 py-3.5 pl-3 pr-4 sm:pr-6"></th>
                  </tr>
                </thead>

                <tbody>
                  @if (adsList.length > 0) {
                    @for (ad of adsList; track ad.id; let i = $index) {
                      <tr>
                        <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                          <p>{{ i + 1 }}</p>
                        </td>
                        <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                          <img [src]="ad.url" alt="Ad preview" class="h-12 w-12 rounded-lg object-cover" />
                        </td>
                        <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                          <p class="whitespace-no-wrap text-gray-900">{{ ad.created_at | date: "MMM d, y 'at' h:mm a" }}</p>
                        </td>
                        <td class="relative whitespace-nowrap border-b py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                          <div class="relative inline-block w-fit cursor-pointer border-gray-200 bg-white text-left">
                            <app-dropdown [id]="ad.id" [actionList]="initAdsDropdownList(ad)"></app-dropdown>
                          </div>
                        </td>
                      </tr>
                    }
                  } @else {
                    <tr>
                      <td colspan="4" class="px-5 py-6 text-center text-sm text-gray-400">
                        No ads uploaded yet.
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <app-table-navigator
          *ngIf="adsTotalCount"
          [total]="adsTotalCount"
          (onNavigation)="navigateAds($event)"
        ></app-table-navigator>
      </div>
    }
  </section>
}

<!-- User Row Template -->
<ng-template #userRow let-user="data" let-i="i">
  <tr>
    <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
      <p>{{ i + 1 }}</p>
    </td>
    <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
      <p class="whitespace-no-wrap text-gray-900">{{ getAccountDisplayName(user) }}</p>
    </td>
    <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
      <p class="whitespace-no-wrap text-gray-900">{{ getUserAccountNumbers(user) }}</p>
    </td>
    <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
      <p class="whitespace-no-wrap text-gray-900">{{ getUserAccountTypes(user) }}</p>
    </td>
    <td
      class="relative whitespace-nowrap border-b py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
    >
      <input
        type="checkbox"
        class="h-4 w-4 cursor-pointer rounded border-gray-300 text-mango focus:ring-2 focus:ring-mango disabled:cursor-not-allowed disabled:opacity-50"
        [checked]="isAccountSelected(user)"
        [disabled]="selectedAccounts.length >= 5 && !isAccountSelected(user)"
        (change)="toggleAccountSelection(user)"
      />
    </td>
  </tr>
</ng-template>